// extracted by mini-css-extract-plugin
export var formContainer = "_dt-0";
export var message = "_dt-1";